export default __webpack_public_path__ + "static/media/txt2_sp.ce714516.png";